'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendLog = undefined;

var _bcGetSpm = require('@alife/bc-get-spm');

var LOG_HOST = '//hd.mmstat.com';

function safeLog() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (window.goldlog) {
    var _window$goldlog;

    (_window$goldlog = window.goldlog).record.apply(_window$goldlog, args);
    return;
  }

  (window.goldlog_queue || (window.goldlog_queue = [])).push({
    action: 'goldlog.record',
    arguments: args
  });
}

function sendLog() {
  if (window.goldlog) {
    var _window$goldlog2;

    (_window$goldlog2 = window.goldlog).record.apply(_window$goldlog2, arguments);
    return;
  }

  // 优先使用sendBeacon
  var cnaMatches = document.cookie && document.cookie.match(/(^|;)\s*cna=([^;]+)/);
  var cna = cnaMatches && cnaMatches[2] || '';
  var spmCnt = (0, _bcGetSpm.getSpmString)();
  if (window.navigator && navigator.sendBeacon && (arguments.length <= 3 ? undefined : arguments[3]) === 'POST') {
    var strParams = JSON.stringify({
      logtype: 2,
      cna: cna,
      'spm-cnt': spmCnt,
      gmkey: arguments.length <= 1 ? undefined : arguments[1],
      gokey: encodeURIComponent('href=' + location.href + '&referrer=' + document.referrer + '&' + ((arguments.length <= 2 ? undefined : arguments[2]) || ''))
    });
    navigator.sendBeacon('' + LOG_HOST + (arguments.length <= 0 ? undefined : arguments[0]), strParams);
    return;
  }
  var img = document.createElement('img');
  var urlParams = 'href=' + location.href + '&referrer=' + document.referrer + '&' + ((arguments.length <= 2 ? undefined : arguments[2]) || '');
  img.src = '' + LOG_HOST + (arguments.length <= 0 ? undefined : arguments[0]) + '?logtype=2&cna=' + cna + '&spm-cnt=' + spmCnt + '&gmkey=' + (arguments.length <= 1 ? undefined : arguments[1]) + '&gokey=' + encodeURIComponent(urlParams);
}

exports.sendLog = sendLog;
exports['default'] = safeLog;